/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMemo } from "react";
import { Link } from "react-router-dom";

const RemunerationMenu = ({
  mainSettings = [],
  branch_id,
  submenuOpen,
  setSubmenuOpen,
  staticDropDown,
  excludedNames,
  name,
  smallState,
  mainIndex,
  settingLevelOne,
  linkName,
}) => {
  const ungroupedSettings = useMemo(() => {
    return mainSettings.filter(
      (f) =>
        f.branch_id === branch_id &&
        !f.groupName &&
        !excludedNames?.includes(f.name?.toLowerCase())
    );
  }, [mainSettings, branch_id, excludedNames]);

  const groupedSettings = useMemo(() => {
    return mainSettings.reduce((acc, setting) => {
      const group = setting.groupName?.trim();
      if (group) {
        if (!acc[group]) acc[group] = [];
        acc[group].push(setting);
      }
      return acc;
    }, {});
  }, [mainSettings]);

  const handleGroupToggle = (index) => {
    setSubmenuOpen((prev) => ({
      ...prev,
      [mainIndex]: index,
      [smallState]: prev[mainIndex] !== index || !prev[smallState],
    }));
  };

  return (
    <li className="submenu">
      <a
        className="text-white"
        onClick={() =>
          setSubmenuOpen((prev) => ({
            ...prev,
            [settingLevelOne]: !submenuOpen[settingLevelOne],
          }))
        }
      >
        <span className="ml-2"> {name}</span>{" "}
        <span className="menu-arrow"></span>
      </a>
      <ul style={{ display: submenuOpen[settingLevelOne] ? "block" : "none" }}>
        {/* Static items */}
        {staticDropDown?.map((item) => (
          <li key={item.slug}>
            <Link to={`/dashboard/${linkName}/${item.slug}`}>{item.name}</Link>
          </li>
        ))}

        {/* Ungrouped dynamic items */}
        {ungroupedSettings.map((settings) => (
          <li className="text-capitalize" key={settings?.slug}>
            <Link to={`/dashboard/${linkName}/${settings?.slug}`}>
              {settings?.name}
            </Link>
          </li>
        ))}

        {/* Grouped dynamic items */}
        {Object.entries(groupedSettings).map(([groupName, items], index) => (
          <li className="text-capitalize" key={groupName}>
            <a className="text-white" onClick={() => handleGroupToggle(index)}>
              <span>{groupName}</span>
              <span className="menu-arrow"></span>
            </a>
            <ul
              style={{
                display:
                  submenuOpen[mainIndex] === index && submenuOpen[smallState]
                    ? "block"
                    : "none",
              }}
            >
              {items.map((item) => (
                <li className="text-capitalize" key={item.slug}>
                  <Link to={`/dashboard/${linkName}/${item.slug}`}>
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        ))}

        {/* Add New Link */}
        <li>
          <Link to={`/dashboard/${linkName}/add-new`}>
            <i
              className="la la-plus mr-1"
              style={{ fontSize: "14px", marginBottom: "3px" }}
            ></i>
            Add New
          </Link>
        </li>
      </ul>
    </li>
  );
};

export default RemunerationMenu;
